import axios from 'axios';

import urlBuilder from '../../helpers/urlBuilder';

const LOQATE_KEY = 'EB49-ZU79-RR11-JR29';
const FIND_URL =
  'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws';
const RETRIEVE_URL =
  'https://api.addressy.com/Capture/Interactive/Retrieve/v1.1/json3.ws';
const GEOCODE_URL =
  'https://api.addressy.com/Geocoding/UK/Geocode/v2.1/json3.ws';

export let Api = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  async findAddress(params) {
    let res = await Api.get(
      `${FIND_URL}?Key=${LOQATE_KEY}&${urlBuilder(params)}`
    );
    return res.data.Items ? res.data.Items : [];
  },
  async retrieveAddress(params) {
    let res = await Api.get(
      `${RETRIEVE_URL}?Key=${LOQATE_KEY}&${urlBuilder(params)}`
    );
    return res.data.Items ? res.data.Items[0] : {};
  },
  async getCoordinates(params) {
    let res = await Api.get(
      `${GEOCODE_URL}?Key=${LOQATE_KEY}&${urlBuilder(params)}`
    );
    return res.data.Items ? res.data.Items[0] : {};
  }
};
